import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

const STATES = [["inherit", "Inherit"], ["allow", "Allow"], ["deny", "Deny"]];

// mode="role": value = array of keys. mode="user": value = {key: allow|deny}, base = role perms
export function PermissionGrid({ catalog, mode, value, onChange, base = [], disabled }) {
  const roleToggle = (k, on) => onChange(on ? [...value, k] : value.filter((x) => x !== k));
  const userSet = (k, st) => {
    const next = { ...value };
    if (st === "inherit") delete next[k]; else next[k] = st;
    onChange(next);
  };
  return (
    <div className="space-y-4" data-testid={`perm-grid-${mode}`}>
      {catalog.map((c) => (
        <div key={c.category} className="rounded-lg border border-border">
          <p className="border-b border-border bg-secondary/40 px-3 py-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">{c.category}</p>
          <div className="grid grid-cols-1 gap-x-4 sm:grid-cols-2">
            {c.perms.map((p) => {
              const locked = p.super_only || disabled;
              if (mode === "role") {
                return (
                  <label key={p.key} className={cn("flex items-center gap-2 px-3 py-2 text-sm", locked && "opacity-50")}>
                    <Checkbox checked={value.includes(p.key)} disabled={locked} onCheckedChange={(v) => roleToggle(p.key, !!v)} data-testid={`role-perm-${p.key}`} />
                    {p.label}{p.super_only && <span className="text-[10px] text-muted-foreground">(Super Admin only)</span>}
                  </label>
                );
              }
              const st = value[p.key] || "inherit";
              const effective = st === "deny" ? false : st === "allow" ? true : base.includes(p.key);
              return (
                <div key={p.key} className={cn("flex items-center justify-between gap-2 px-3 py-1.5 text-sm", locked && "opacity-50")}>
                  <span className="flex items-center gap-2">
                    <span className={cn("h-2 w-2 rounded-full", effective ? "bg-emerald-500" : "bg-rose-500/60")} />
                    {p.label}
                  </span>
                  <div className="flex overflow-hidden rounded-md border border-border text-[11px]">
                    {STATES.map(([k, l]) => (
                      <button key={k} type="button" disabled={locked} onClick={() => userSet(p.key, k)} data-testid={`user-perm-${p.key}-${k}`}
                        className={cn("px-2 py-1 transition-colors", st === k ? (k === "deny" ? "bg-rose-500 text-white" : k === "allow" ? "bg-emerald-500 text-white" : "bg-primary/15 text-primary") : "hover:bg-accent")}>
                        {l}
                      </button>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
